'use client'
import { createContext, useContext, useState, useEffect } from 'react'

const LayoutContext = createContext()

export function LayoutProvider({ children }) {
    const [hideLayout, setHideLayout] = useState(false)

    return (
        <LayoutContext.Provider value={{ hideLayout, setHideLayout }}>
            {children}
        </LayoutContext.Provider>
    )
}

export function useLayout() {
    const context = useContext(LayoutContext)
    if (!context) {
        throw new Error('useLayout must be used within LayoutProvider')
    }
    return context
}

// Hook：頁面使用這個，自動隱藏 Header/Footer，離開時恢復
export function useHideLayout() {
    const { setHideLayout } = useLayout()

    useEffect(() => {
        setHideLayout(true)
        return () => setHideLayout(false)
    }, [setHideLayout])
}